'use strict';

var crypto = require('browserify-aes');

module.exports = {
  createCipheriv: crypto.createCipheriv,
  createDecipheriv: crypto.createDecipheriv
};